"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _settingsWrapper = _interopRequireDefault(require("../../../../helpers/settingsWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var initialValues = exports.initialValues = {
  mustTakeInOrder: false,
  closeModalOnComplete: false
};
var Settings = function Settings(_ref) {
  var questSettings = _ref.questSettings;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "mustTakeInOrder",
    component: _cccisdFormik.CccisdToggle,
    label: "User must take Deployments in order"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "closeModalOnComplete",
    component: _cccisdFormik.CccisdToggle,
    label: "Close modal automatically after completing each deployment"
  }));
};
var _default = exports["default"] = (0, _settingsWrapper["default"])({
  initialValues: initialValues
})(Settings);